export default {
  SPAN_COLLECTION: "span",
  CELL_COLLECTION: "cells",
  SERIES: "series",
  CELL_COLOR: "ferj",
};
